import { render, staticRenderFns } from "./editPromotionBanner.vue?vue&type=template&id=c787aff0&lang=pug"
import script from "./editPromotionBanner.vue?vue&type=script&lang=js"
export * from "./editPromotionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports